module.exports = __webpack_public_path__ + "img/expand-up.605faa76.svg";